import { useEffect, useState } from 'react';

import { getInjector } from '@/services/angularjs-bridge';

const usePhysicalAttributeService = () => {
    // eslint-disable-next-line
    const [physicalAttributeService, setphysicalAttributeService] = useState<any>();
    useEffect(() => {
        const angularJsInjector = getInjector();
        const _physicalAttributeService = angularJsInjector.get('PhysicalAttributeService');
        setphysicalAttributeService({..._physicalAttributeService});
    }, []);

    return { physicalAttributeService };
};
export default usePhysicalAttributeService;
